export default __webpack_public_path__ + "static/media/fidakhan.ffe829ee.jfif";